import React from 'react'
import { render as renderAmis } from 'amis'
import { requestWithoutLogout as request } from "@/utils/request"

class AmisRender extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return renderAmis(
      // 这里是 amis 的 Json 配置。
      this.props.value,
      {
        // props...      
      },
      // env
      this.props.env || {
        fetcher: config => {
          return request({
            url: config.url,
            method: config.method,
            data: config.data,
            // params: config.query,
            headers: config.headers
          })
        }
      }
    )
  }
}

export default AmisRender